var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlovenia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0600f5",
    d: "M1 11H31V21H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    transform: "rotate(180 16 24)",
    fill: "#ea3323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.612,8.569c2.019-.889,4.318-.889,6.337,0,.331,4.68-.725,7.333-3.168,7.958-2.443-.625-3.499-3.278-3.168-7.958Z",
    fill: "#0600f5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.781,10.646l.767,1.534,.511-.682,1.278,1.705c0,.079-.011,.158-.033,.234-.356,1.245-1.299,2.237-2.524,2.656-1.225-.419-2.168-1.411-2.524-2.656-.022-.076-.033-.155-.033-.234l1.278-1.705,.511,.682,.767-1.534Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.372,8.68c.08-.038,.16-.075,.241-.111l.253,4.044c.108,1.728,1.266,3.213,2.915,3.74,1.65-.527,2.807-2.012,2.915-3.74l.253-4.044c.081,.036,.161,.073,.241,.111l-.247,3.949c-.116,1.859-1.378,3.448-3.162,3.984-1.784-.535-3.046-2.125-3.162-3.984l-.247-3.949Z",
    fill: "#ea3323"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlovenia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Slovenia.2f823dc34c62dc7179ef70042b501673.svg";